/* eslint-disable no-unused-vars */
/* global G */
import { curry } from 'lib/util'
import update from 'app/_shared/events/util/update'

/**
 * Set Title From Node Event Handler
 *
 * Sets the action title for the {@link Hotspot} component based on the currently
 * selected `node` inside the action state.
 *
 * @param {Gaia.AppModule.Spec} module          the current module composition object
 * @param {Gaia.Component.Spec} component       the current action's main component
 * @param {Gaia.AppModule.EventHandler} event   the event object that triggered this handler
 */
const setTitleFromNode = (module, component, event) => {
  const model = module[G.MODEL]
  const key = model[G.STATE][G.REF]

  const moduleState = module[G.STATE]
  const actionUi = moduleState[G.ACTION][G.UI]
  const { node } = moduleState[G.ACTION][G.STATE]
  const { obfuscateSerial = null } = moduleState

  const { depth, name } = node || {}
  const shouldObfuscate = obfuscateSerial && obfuscateSerial === key

  const isChild = depth !== 0
  const isDirectory = node?.type === 'Directory'

  if (name && isChild && isDirectory) {
    actionUi.title = name
    actionUi.subTitle = null
  }

  if (!isChild && isDirectory) {
    const { equipment: { [G.CACHE]: {
      name: equipmentName = null,
      serial = null,
      serialLong = null,
    } = {} } = {} } = model[G.CHILDREN]

    const serialValue = serialLong
      ? (shouldObfuscate && `${serialLong.slice(0, -7)}XXXXXXX`) || serialLong
      : serial

    actionUi.title = equipmentName;
    (serialLong || serial) && (actionUi.subTitle = serialValue)
  }
  update(module, component, event)
}

export default curry(setTitleFromNode)
